module.exports = __webpack_public_path__ + "img/kn.2509e6b6.svg";